import React from 'react';
import { motion } from 'framer-motion';
export function ProductIntro() {
  return <section className="w-full bg-white px-5 py-12 sm:py-20" data-id="element-151" data-mp="22l5dz2tolmka">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.3
    }} transition={{
      duration: 0.5
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-152" data-mp="22jc31bc1cg6h">
        <span className="mb-5 inline-block rounded-full border border-cobalt/40 bg-cobalt/10 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-cobalt-deep" data-id="element-153" data-mp="2ge4oeqelwqkz">
          📦 Tutto ciò che contiene il sistema
        </span>
        <h2 className="font-serif-display text-3xl font-bold leading-tight text-ink sm:text-5xl" data-id="element-154" data-mp="26l60laqxp42f">
          Tutto il necessario per insegnare chimica in modo più visuale, organizzato ed efficace
        </h2>
        <p className="mt-5 text-base font-medium text-cobalt-deep sm:text-lg" data-id="element-155" data-mp="342e6bh8p8u6u">
          CHIMICA VISIVA™ — Il sistema completo per insegnare chimica
        </p>
        <div className="mx-auto mt-6 h-px w-16 bg-cobalt/40" data-id="element-156" data-mp="ug6sq9e8vyz0" />
        <p className="mt-6 text-sm leading-relaxed text-ink/70 sm:text-base" data-id="element-157" data-mp="ph3xthrzb94r">
          CHIMICA VISIVA™ riunisce in un’unica raccolta materiali pronti per la classe dedicati alla
          materia, alla struttura atomica, alla periodicità, ai legami chimici, alle reazioni, alla
          stechiometria, alla chimica organica, alle biomolecole e alle applicazioni scientifiche.
        </p>
      </motion.div>
    </section>;
}